<template>
  <div class="container">
    <pre style="display: none">{{ pagination | pretty_json }}}</pre>
    <h1>Lista de Objetivos</h1> 
    <div class="card">
      <div class="card-body">
        <b-table striped hover :items="objectives" :fields="fields">
          <template #cell(cpf)="row">
            {{ row.item.cpf | cpf }}
          </template>
          <template #cell(actions)="row">
            <Actions
              :item="row.item"
              :view_show="$can('objective:view')"
              :view_edit="$can('objective:edit')"
              :view_delete="$can('objective:delete')"
              view_to="objectives_show"
              edit_to="objectives_edit"
              @delete="delete_objective"
            />
          </template>
        </b-table>
      </div>
    </div>
    <div class="overflow-auto mt-4">
      <b-pagination-nav
        v-model="page"
        :link-gen="linkGen"
        :number-of-pages="pagination.last_page"
        use-router
      ></b-pagination-nav>
    </div>
  </div>
</template>

<script>
import Actions from "@/components/Table/Actions.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: { Actions },
  data() {
    return {
      page: 1
    };
  },
  computed: {
    ...mapState("objectives", ["objectives", "pagination"]),
    fields() {
      return [
        { key: "id", label: "#" },
        { key: "name", label: "Objetivo" },
        { key: "actions", label: "#" }
      ];
    }
  },
  methods: {
    ...mapActions("objectives", ["ActionGetAll"]),
    delete_objective(objective) {
      return objective;
    },

    linkGen(pageNum) {
      return pageNum === 1 ? "?" : `?page=${pageNum}`;
    }
  },
  async created() {
    if (this.$route.query.page > 1) {
      this.page = this.$route.query.page;
    }
    await this.ActionGetAll({ page: this.page });
  }
};
</script>

<style></style>
